import { type FunctionalComponent, h } from '@stencil/core';
import { addProduct, compareCtaText } from '../uiaas-compare-bar-labels';
import type { labelProviderInterface } from '../../../LabelProviderInterface';

interface ICompareComparisonPartial {
  numberOfSelectedItems: number;
  redirectionUrl: string;
  labelProvider: labelProviderInterface;
}

export const CompareComparisonPartial = (
  props,
): FunctionalComponent<ICompareComparisonPartial> => (
  <div class="compare-wrapper-bar-comparison">
    {props.numberOfSelectedItems > 1 ? (
      <qds-button
        href={props.redirectionUrl}
        target="_blank"
        data-compare-area={'compare_now'}
        text={props.labelProvider(compareCtaText.label, compareCtaText.fallback)}
      />
    ) : (
      <section class="compare-wrapper-bar-comparison__info">
        <se-icon size="small">information_stroke</se-icon>
        <span>
          {props.labelProvider(addProduct.label, addProduct.fallback)}
        </span>
      </section>
    )}
  </div>
);
